// https://taxation-customs.ec.europa.eu/territorial-status-eu-countries-and-certain-territories_en
// https://climate.ec.europa.eu/eu-action/transport-emissions/reducing-emissions-shipping-sector_en#paragraph_716
export const euEtsCountries = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czechia',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Netherlands',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
  'Monaco',
  'San Marino',
  'Andorra',
  'Åland Islands',
  'French Guiana',
  'Gibraltar',
  'Guadeloupe',
  'Madeira',
  'Martinique',
  'Mayotte',
  'Réunion',
  'Saint Martin (French Part)',
  'Guyana',
  'Norway',
  'Iceland',
];

export const euEtsCountriesSet = new Set(euEtsCountries);

const _missing = [
  //Missing from country db:
  'Açores',
  'Madeira',
  'Canarias',
];

const _excluded = [
  'Greenland',
  'Faroe Islands',
  'French Polynesia',
  'New Caledonia',
  'Saint Barthélemy',
  'Saint Pierre and Miquelon',
  'Wallis and Futuna Islands',
  'Aruba',
  'Bonaire, Sint Eustatius and Saba',
  'Curaçao',
  'Sint Maarten (Dutch part)',
  'Anguilla',
  'Bermuda',
  'British Indian Ocean Territory',
  'British Virgin Islands',
  'Cayman Islands',
  'Falkland Islands (Malvinas)',
  'Isle of Man',
  'Jersey',
  'Montserrat',
  'Pitcairn',
  'Saint Helena',
  'South Georgia and the South Sandwich Islands',
  'Turks and Caicos Islands',
  'Svalbard and Jan Mayen Islands',
];

const _excluded_missing_country_in_db = [
  'British Antarctic Territory',
  'Bailiwick of Guernsey',
  'Henderson',
  'Ducie and Oeno Islands',
  'Ascension and Tristan da Cunha',
  'Akrotiri',
  'Dhekelia',
];
